import { useApiClientStore } from '../stores/useApiClientStore';

import { ApiResult } from '../types';
import { AdminRequest } from '../types/admin-request';

export async function submitAdminRequest(payload: AdminRequest): Promise<ApiResult> {
  const api = useApiClientStore().getClient();

  const fd = new FormData();

  fd.append('proxyDetails[firstName]', payload.proxyDetails?.firstName ?? '');
  fd.append('proxyDetails[lastName]', payload.proxyDetails?.lastName ?? '');
  fd.append(
    'proxyDetails[relationshipToPatient]',
    payload.proxyDetails?.relationshipToPatient ?? '',
  );
  fd.append('reporterType', payload.reporterType);

  fd.append('adminRequest', payload.adminRequest ?? '');

  for (const file of payload.attachments ?? []) {
    fd.append('attachments[]', file, file.name);
  }

  return api.postRawFiles<ApiResult>('/patient-portal/admin-request', fd);
}
